import React from 'react';
import { View, StyleSheet } from 'react-native';
import ShimmerPlaceHolder from 'react-native-shimmer-placeholder';
import { getScreenHeight, getScreenWidth } from '../../utils/LayoutUtility';

const SelfieCarouselPlaceholder = (props) => {
  const shimmerData = [1, 2, 3];
  const { loadMore, showFooterShimmer } = props;

  const CarouselPlaceholder = () => {
    return (
      <View style={styles.shimmerContainer}>
        {/* Shimmer for Title */}
        <ShimmerPlaceHolder
          autoRun
          style={styles.shimmerTitle}
          colorShimmer={['#E0E0E0', '#F5F5F5', '#E0E0E0']}
        />
        {/* Shimmer for Rectangular Cards */}
        <View style={styles.cardShimmerRow}>
          {shimmerData.map((_, index) => (
            <ShimmerPlaceHolder
              key={index}
              autoRun
              style={styles.cardShimmer}
              colorShimmer={['#E0E0E0', '#eeeeee', '#fafafa']}
            />
          ))}
        </View>
      </View>
    );
  };

  if (loadMore || showFooterShimmer) {
    return (
      <View style={styles.loadMoreShimmer}>
        <CarouselPlaceholder />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      {shimmerData.map((_, index) => (
        <CarouselPlaceholder key={index} />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    height: getScreenHeight(),
    width: getScreenWidth(),
    alignItems: 'center',
  },
  shimmerContainer: {
    marginBottom: 20,
    width: getScreenWidth() - 24,
    overflow: 'hidden',
  },
  shimmerTitle: {
    width: 200,
    height: 20,
    marginBottom: 10,
    borderRadius: 5,
    marginTop: 10,
    alignSelf: 'center',
  },
  cardShimmerRow: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    marginTop: 20,
  },
  cardShimmer: {
    width: 240,
    height: 340,
    borderRadius: 10,
  },
  loadMoreShimmer: {
    width: getScreenWidth(),
    alignItems: 'center',
  },
});

export default SelfieCarouselPlaceholder;
